import { Link } from 'react-router-dom';
import AnimatedSection from '../../../components/base/AnimatedSection';

export default function CtaSection() {
  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/971f3a7c66a24ccb162969085fc1b05a.jpg"
          alt="CTA Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-900/90 via-gray-900/85 to-emerald-900/90"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-8 text-center">
        <AnimatedSection animation="fadeUp">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/20 backdrop-blur-md rounded-full text-teal-300 mb-8 border border-teal-400/30">
            <i className="ri-sparkling-2-line"></i>
            <span className="text-sm font-medium">立即開始您的數位轉型之旅</span>
          </div>
          <h2 className="text-5xl font-extrabold text-white mb-6 leading-tight">
            準備好讓 AI 為您的<br />企業創造價值了嗎？
          </h2>
          <p className="text-white/75 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
            與恩誠國際的專家團隊進行免費諮詢，了解最適合您企業的 AI 數位轉型方案。
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <a
              href="mailto:enchengai.com@gmail.com"
              className="group px-10 py-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-lg font-semibold text-base whitespace-nowrap cursor-pointer shadow-2xl shadow-teal-500/40 hover:from-teal-600 hover:to-emerald-600 transition-all hover:scale-105 flex items-center gap-2"
            >
              立即免費諮詢
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
          <div className="flex items-center justify-center gap-8 mt-12 flex-wrap">
            {[
              { icon: 'ri-shield-check-line', text: '免費初步診斷' },
              { icon: 'ri-time-line', text: '48小時內回覆' },
              { icon: 'ri-customer-service-2-line', text: '專屬顧問服務' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-white/70 text-sm">
                <i className={`${item.icon} text-teal-400 text-lg`}></i>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
